import axios from "axios";
import {
  API_PATHS,

} from "../utils/constants/api.constants";

const logout =()=>{
  localStorage.clear();
  localStorage.setItem("logout", Date.now().toString());
  localStorage.setItem("role", "client");
  }


//for getting client profile
class ClientService {
  static getProfile() {
    let api = API_PATHS.getemployerProfile;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api, { headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

  static getplanHistory(params = {}) {
    let api = API_PATHS.clientPlanHistoryV2;
    const query = new URLSearchParams();
    if (params.active != null) query.set("active", params.active);
    if (params.expired != null) query.set("expired", params.expired);
    if (params.category) query.set("category", params.category);
    if (params.limit != null) query.set("limit", params.limit);
    if (params.page != null) query.set("page", params.page);
    const qs = query.toString();
    if (qs) api = `${api}?${qs}`;

    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
        .get(api, { headers: {"x-access-token" : token}})
        .then((response) => {
            if (response.data) {
                // localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
        }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}

  static getCateringDetails(id) {
    let api = "";
    let type="catering";
    api = API_PATHS.viewchefDetails +"?id="+id+"&cookType="+type;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api, { headers: { "x-access-token": token } })
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

  static getHouseDetails(id) {
    let api = "";
    let type="housecook";
    api = API_PATHS.viewchefDetails +"?id="+id+"&cookType="+type;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api,  { headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

  static getPartyCookDetails(id) {
    let api = "";
    let type="partycook";
    api = API_PATHS.viewchefDetails +"?id="+id+"&cookType="+type;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api,  { headers: { "x-access-token": token } })
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }


  static getRequirement() {
    let api = "";
    api = API_PATHS.getrequirement;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api, { headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
  }

  static getRequirementV2() {
    const api = API_PATHS.getrequirementV2;
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api, { headers: { "x-access-token": token } })
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

  static saveRequirementV2(item) {
    const api = API_PATHS.saverequirementV2;
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .post(api, item, { headers: { "x-access-token": token } })
      .then((response) => response.data)
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

  //edit client requirement (legacy)
  static editRequirement(item) {
    let api = "";
    api = API_PATHS.addrequirement;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .post(api, item,{ headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
  }


  //for editing client profile
    static editclientProfile(item) {
    let api = "";
    api = API_PATHS.editemployerProfile;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .put(api, item, { headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }

//post job
  static postEvents(item) {
    const api = API_PATHS.postEvents;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .post(api, item, { headers: { "x-access-token": token } })
      .then((response) => {
        const data = response.data;
        if (data?.status === 0) {
          const error = new Error(
            data.message || data.msg || "Event post failed"
          );
          error.response = response;
          throw error;
        }
        return data;
      })
      .catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }


  static editEvents(item) {
    let api = API_PATHS.editEventsV2;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .put(api, item, { headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
          logout();
        }
        throw Error;
      });
  }


  //get event for client
  static getEvents(id) {
    let api = "";
    api = API_PATHS.getEvents + '?id='+id;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api,{ headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
  }


  static getAllEvents() {
    let api = "";
    api = API_PATHS.getEvents ;
    let user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    return axios
      .get(api,{ headers: { "x-access-token": token } })
      .then((response) => {
        if (response.data) {
          // localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data;
      }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
  }


//find catering profiles
static findCatering(item) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .post(API_PATHS.findcatering, item, {
      headers: { "x-access-token": user.data.token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}


//find house cook profiles
static findHouseCook(item) {
  let api = "";
  api = API_PATHS.findhousecook;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .post(api,item,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}

static findHouseCookV2(payload) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .post(API_PATHS.findhousecookV2, payload, {
      headers: { "x-access-token": user.data.token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

static getClientPointsActiveV2() {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .get(API_PATHS.getClientPointsActiveV2, {
      headers: { "x-access-token": user.data.token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}

//find party cook profiles
static findPartycook(item) {
  const user = JSON.parse(localStorage.getItem("user"));
  return axios
    .post(API_PATHS.findpartycook, item, {
      headers: { "x-access-token": user.data.token },
    })
    .then((response) => response.data)
    .catch((Error) => {
      if (Error?.response?.status === 401) {
        logout();
      }
      throw Error;
    });
}


//disable accounts for client and employer
static disableAccount() {
  let api = "";
  api = API_PATHS.disableaccount;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
    
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}

//enable accounts for client and employer
static enableAccount() {
  let api = "";
  api = API_PATHS.enableaccount;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}


//delete accounts for client and employer
static deleteAccount(item) {
  let api = "";
  api = API_PATHS.deleteaccount;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  const config = {
    headers: {
      "x-access-token": token,
    },
    data: item,
  };
  return axios.delete(api,config)
  .then((response) => {
    if (response.data) {
    }
    return response.data;
  });
}

static canceldeleteAccount() {
  let api = "";
  api = API_PATHS.canceldeleterequest;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}



static getEventRequestDetails(id) {
  let api = "";
  api = API_PATHS.vieweventrequestdetails +"?id="+id;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}

static getRequirementRequestDetails(id) {
  let api = "";
  api = API_PATHS.houseinterestdetails +"?id="+id;
  let user = JSON.parse(localStorage.getItem("user"));
  const token = user.data.token;
  return axios
    .get(api,  { headers: { "x-access-token": token } })
    .then((response) => {
      if (response.data) {
        // localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    }).catch((Error) => {
        if (Error?.response?.status === 401) {
         
          logout();
        }
        });
}



  static removeuserDetails() {
    localStorage.removeItem("user");
  }

  static getuserDetails() {
    return JSON.parse(localStorage.getItem("user"));
  }
}

export default ClientService;